import React, { Component } from "react";
import styled from "styled-components";
import ColorPicker from "./ColorPickerComponent";
import ImagePicker from "./ImagePicker";
import { PropListItem } from "./styles";

const CustomPropListItem = styled(PropListItem)`
  flex-direction: column;
  > div{
    width: 100%;
  }
`;

class Background extends Component{
  constructor(){
    super();
    this.state = {
      color: null
    }
  };

  componentDidMount(){
    const { currentValue } = this.props;
    this.setState({ color: currentValue })
  }

  handleChange = colorProps => {
    this.setState({ color: colorProps.rgb })
  }
  
  render(){
    const { currentValue } = this.props;
    const { color } = this.state;
    
    return (
      <CustomPropListItem>
        <ImagePicker />
        <ColorPicker 
          color={!color ? currentValue : color}
          onChange={this.handleChange}
          label="Color"
        />
      </CustomPropListItem>
    )
  }
}

export default Background;
